<template>
  <button
    id="intercomtest"
    class="flex items-center justify-start text-primary cursor hover:underline text-sm p-2 bg-dull-light"
    v-on="$listeners"
    v-bind="$attrs"
    >  
    
      <Icon class="mr-2" name="book-open" size="small"/>

    <span class="">
      <slot />
    </span>

  </button>
</template>

<script>

import Icon from '../Icon'

export default {
  name: 'SupportLink',

  components: {Icon},

  props: {

    link: {
      type: String, 
      default() { 
        return ''
      }
    }

  }
}

</script>

<style scoped>
  .info {
    @apply
      bg-dull-light
  }

  .info .alertIcon {
    @apply
      text-dull
  }

  .info .alert-title {
    @apply
      text-dull-dark
  }

  .line {
    @apply
      bg-transparent
  }

  .pane {
    @apply
      p-4
  }

</style>
